import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { AdjacentType } from '@iotv/iotv-v3-types';
import { TabPanel } from '@mui/lab';
import { useContext } from 'react';
import { AppMainViewContext } from '../../../../ContextProviders/AppContextProvider';
import { useObjectByTypeAndName } from '../../../../hooks/useObjectByTypeAndName';
import { getZombieInstanceFromPrimaryKey } from '@iotv/datamodel-core';
const debug = process.env.REACT_APP_DEBUG && false;
export const AutoCompleteSearch = ({ value }) => {
    const [appContext] = useContext(AppMainViewContext);
    const { contextCustomer } = appContext;
    const initialType = 'Property';
    const initialSelectedObject = getZombieInstanceFromPrimaryKey(`Property:c5be556f-b7f0-4850-9042-9e5179daaaa4`, { name: '80 Okaroro' });
    const { components: { entitySelector, objectTypeSelector }, state: { currentEntity: [currentEntity, setCurrentEntity], objectTypeState, }, } = useObjectByTypeAndName({
        contextObject: contextCustomer,
        adjacencyType: AdjacentType.CHILD,
        currentObject: initialSelectedObject,
        currentObjectTypeId: initialType,
        validTypeIds: ['Device', 'Property'],
    });
    return (_jsxs(TabPanel, { value, children: [_jsx(Typography, { variant: 'h6', children: "Autocomplete test" }), objectTypeSelector, entitySelector, _jsx(Typography, { children: ` Current entitty: ${currentEntity ? currentEntity.name : 'Nothing '}` })] }, 'batchPut'));
};
